import { render, staticRenderFns } from "./ViewPostBody.vue?vue&type=template&id=230a0084&scoped=true&"
import script from "./ViewPostBody.vue?vue&type=script&lang=js&"
export * from "./ViewPostBody.vue?vue&type=script&lang=js&"
import style0 from "./ViewPostBody.vue?vue&type=style&index=0&id=230a0084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a0084",
  null
  
)

export default component.exports